/*
 * Check if the click is valid for opening a custom context menu.
 * We should not prevent the default context menu on links, inputs, or if there is text selected.
 */
export const isValidContextMenuClick = (e: MouseEvent | React.MouseEvent) => {
  const target = e.target;
  if (!(target instanceof HTMLElement)) return false;
  const isExcludedElement =
    (target.tagName === "A" && "href" in target && !!target.href) ||
    target.tagName === "INPUT";

  const hasTextSelection = window.getSelection()?.toString() !== "";

  return !isExcludedElement && !hasTextSelection;
};
